import { getCoordinatorApi } from "@/lib/api";
import type {
  CreateProjectFormData,
  Project,
  SingleProjectResponse,
} from "../types";

export async function createProject(
  project: CreateProjectFormData,
  organizationId: string
): Promise<Project> {
  const api = getCoordinatorApi({ organizationId });
  const response = await api.post<SingleProjectResponse>("/projects", project);
  return response.data.data;
}
